module.exports = __webpack_public_path__ + "img/blockS3-card2.6782042f.svg";